import { Button } from "@mui/material"
import React, {useState} from "react"
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import "./revisionSheetCard.css"
import { useSelector, useDispatch } from 'react-redux';
interface RevisionSheetCard {
    data:any;
    ind:number;
    selectRevisionSheet:Function;
	active:boolean
}

const palletColors =["#FDF2D6","#E3FFED","#FDE6E4","#DCC9FF","#FFC9F6","#EBF3FE"]

const RevisionSheetCard = (props:RevisionSheetCard)=>{
    const {data, ind,selectRevisionSheet,active} = props
    const gymState = useSelector((state: any) => state.gym);

	const {
		filteredData,
		solvedStatus,
		difficulty,
		name,
		tags,
		page,
		bookmarked,
		gymloading,
		courseId,
		questionSource,
		filterCourseName,
		revisionSheets,
		revisionSheetId
	} = gymState;

    return (
        <div className="item" >
			<div className="revision-sheet-card-wrapper" style={{border:active?"2px solid #2666be":"1px solid lightgray",color:active?"black":"darkslategray",background:palletColors[ind%palletColors.length]}} onClick={()=>selectRevisionSheet(data.id)} >
				{data.id!=="all_ques" && <p style={{fontSize:'11px',color:'#2666be'}} >Acciojob's Curated List of</p>}
				<h5 >{data.name}</h5>
				{data.id!=="all_ques" && <div>
					<p className="revision-sheet-solved-count" >{data.solvedCount}/{data.totalCount} solved</p>
				</div>}
			</div>
        </div>
    )
}

export default RevisionSheetCard